import { render, staticRenderFns } from "./IndustryAnalysis.vue?vue&type=template&id=146c5c62&scoped=true"
import script from "./IndustryAnalysis.vue?vue&type=script&lang=js"
export * from "./IndustryAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146c5c62",
  null
  
)

export default component.exports